import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FilterMatchMode, SelectItem } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})
export class TableConfigService {
    public static readonly TableRowsOptions: number[] = [10, 25, 50];

    public static readonly TableRowDefault: number =
        TableConfigService.TableRowsOptions[0];

    constructor(private readonly translateService: TranslateService) {}

    public getTableCurrentPageReportTemplate(): string {
        return `${this.translateService.instant(
            'shared.primeNG.pageReportTemplate.first'
        )} {first} ${this.translateService.instant(
            'shared.primeNG.pageReportTemplate.to'
        )} {last} ${this.translateService.instant('shared.primeNG.pageReportTemplate.from')} {totalRecords}`;
    }

    public getEqualsMatchModeOptions(): SelectItem[] {
        return [
            {
                label: this.translateService.instant('primeNG.equals'),
                value: FilterMatchMode.EQUALS,
            },
        ];
    }
}
